import { render, staticRenderFns } from "./ApproximatingAvogadrosNumberSIM.vue?vue&type=template&id=85059bc4&"
import script from "./ApproximatingAvogadrosNumberSIM.vue?vue&type=script&lang=ts&"
export * from "./ApproximatingAvogadrosNumberSIM.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports